import React, { ReactNode } from "react";

import { Box, Typography } from "@mui/material";

interface SectionLayoutProps {
  title: string;
  children: ReactNode;
}

const SectionLayout = ({ children, title }: SectionLayoutProps) => {
  return (
    <>
      <Box
        sx={{
          padding: "16px",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ alignItems: "center", flexDirection: "row" }}>
          <Typography
            sx={{
              fontSize: 18,

              fontWeight: "500",
              letterSpacing: 1,
              lineHeight: "23.5px",
            }}
          >
            {title}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          paddingHorizontal: 16,
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "space-around",
        }}
      >
        {children}
      </Box>
    </>
  );
};

export default SectionLayout;
